<div class="news-audit-view" [class.mobile]="(screenSize$ | async)?.isMobile">
  <div class="news-audit-view-container">
    <app-news-audit-title
      [auditData]="auditData$ | async"
      [loading]="loading$ | async"
    ></app-news-audit-title>
  </div>

  <div class="audit-info">
    <app-chartmap-info></app-chartmap-info>
  </div>
</div>
